import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UIEffectItem, uiEffects } from '../models/ui-effects.model';
import { CardModule } from 'primeng/card';
import { RippleModule } from 'primeng/ripple';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TagModule } from 'primeng/tag';

import { map } from 'rxjs';

@Component({
  selector: 'app-effect-picker',
  standalone: true,
  imports: [
    CardModule,
    RippleModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    ReactiveFormsModule,
    TagModule
  ],
  templateUrl: './effect-picker.component.html',
  styleUrl: './effect-picker.component.scss'
})
export class EffectPickerComponent implements OnInit {
  effects = uiEffects
  search = new FormControl('')

  @Output() selectEffect = new EventEmitter<UIEffectItem>()
  ngOnInit(): void {
    this.search.valueChanges.pipe(
      map(value => {
        if (!value) {
          return uiEffects
        }
        const lower = value.toLowerCase()
        if (value.length > 0) {
          return uiEffects.filter(effect => effect.label.toLowerCase().indexOf(lower) >= 0)
        }
        return uiEffects
      })
    ).subscribe(effects => {
      this.effects = effects
    })
  }
}
